import { render, staticRenderFns } from "./SupportButton.vue?vue&type=template&id=0ac69eef&scoped=true"
import script from "./SupportButton.vue?vue&type=script&lang=js"
export * from "./SupportButton.vue?vue&type=script&lang=js"
import style0 from "./SupportButton.vue?vue&type=style&index=0&id=0ac69eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac69eef",
  null
  
)

export default component.exports